module.exports = __webpack_public_path__ + "static/media/video.8798d115.svg";